import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-brand-setup',
  templateUrl: './customer-brand-setup.component.html',
  styleUrls: ['./customer-brand-setup.component.css']
})
export class CustomerBrandSetupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
